import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Scrollbar, Navigation } from 'swiper';
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "./style.css";
import vector from "../../Assets/Images/arrow/Vector.svg";

SwiperCore.use([Scrollbar, Navigation]);

export default function Carousel(props) {
  return (
    <div className='swiper-layer'>
      {/* <div className={`swiper-button ${props.id}-button-prev`}>
        <img src={vector} className="arrow-pre" />
      </div>
      <div className={`swiper-button ${props.id}-button-next`}>
        <img src={vector} className="arrow-nex" />
      </div> */}
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
        scrollbar={{ hide: true }}
        className="mySwiper"
        navigation={{
          nextEl: `.${props.id}-button-next`,
          prevEl: `.${props.id}-button-prev`,
          // disabledClass: "swiper-button-disabled"
        }}
      >
        {props.children}
      </Swiper>
    </div>

  );
}

